// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xsuM","newExpiryDate":"styles_newExpiryDate__2itX_","footer":"styles_footer__3Sttb"};